
const themeColors = {
  primary: '#4a176c',
  secondary: '#76b434',
  tertiary: '#e5743a'
}

export default themeColors
